import { render, staticRenderFns } from "./AttachIcon.vue?vue&type=template&id=04375f09&"
import script from "./AttachIcon.vue?vue&type=script&lang=ts&"
export * from "./AttachIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports